import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { createRoute, PATHS } from '@core/router/paths';
import Loader from '@shared/components/reusables/loader';
import { useGetMemberships } from '@shared/services/get-memberships';
import { getCredentials } from '@src/shared/utils/get-credentials';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

const GuestGuard = ({ children }: { children: ReactNode }) => {
  const { refreshToken } = getCredentials();
  const { data: memberships, isPending } = useGetMemberships({
    enabled: !!refreshToken,
    select: (data) => data.filter((m) => m.is_active),
    // We explicitly set queryKey here to separate the query from the actual query key,
    // separation for guest and logged in users
    // this prevent unexpected behavior during transition from guest to logged in user e.g, login, signup, etc.
    queryKey: [`${QUERY_KEYS.getMemberships}-guest`],
  });

  const firstOrgSlug = memberships?.[0]?.organization.slug;

  if (refreshToken && isPending) {
    return <Loader />;
  }

  if (firstOrgSlug) {
    return (
      <Navigate
        to={createRoute(PATHS.PROGRAMS, firstOrgSlug)}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default GuestGuard;
